import { ChangeDetectionStrategy, Component } from '@angular/core';

import { InputConfig } from "@template-ui/types/ez-form.types";
import { DocMeta } from "@template-ui/decorators";
import { UiLibraryModule } from "@template-ui/template-ui.module";
import { EzGridDsConfig } from "@template-ui/types/ez-grid.types";
import { EzGridComponent } from "@template-ui/components/ez-grid/ez-grid.component";
import { AppBaseComponent } from "@app/shared/components/app-base.component";
import { EzGridColTypes } from "@template-ui/types";
import { SHOWCASE_LIBRARY_NAMES } from "../../showcase-library.constants";
@DocMeta({
  hide: true,
  showcaseAttachTo: [{ libName: SHOWCASE_LIBRARY_NAMES.BASE, classNames: ["EzGridComponent"] }],
  showcaseTitle:"Simple grid using rowData",
  showcaseDesc: `
  ` })
@Component({
  selector: 'ui-grid.sample, ez-grid.sample',
  imports: [UiLibraryModule, EzGridComponent],
  templateUrl: './ez-grid.sample.html',
  styleUrl: './ez-grid.sample.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EzGridSampleComponent extends AppBaseComponent {

  // Enpoints used for ezGrids
  userSettingsEndpoint = this.apis.core.getAppUserSettingsByPartId(this.user.partId() || 0);

  //myPagesEndpoint = this.apis.core.getAppPagesGetMyPages();

  userSettingsDsConfig: EzGridDsConfig = {
    datasourceId: "UserSettings",

    bindings: [{ bindingType: "READ", endpoint: this.userSettingsEndpoint }],

    colDefs: [
      { field: "PartId", headerName: "Participant Id" },
      { field: "SettingName", headerName: "Setting", filter: true, suppressHeaderFilterButton: false },
      { field: "AddDtt", headerName: "Added", type: [EzGridColTypes.WrapText] },
      { field: "rando", headerName: "Random UUID generated by responseTransform" }
    ]
  };

  constructor() {
    super();
  }

  userSettingsfilterInputConfigs: InputConfig[] = [{ name: "SettingName", type: "text" }];

  responseTransform = (rows: any[]): any[] => {
    return this.responseTransformInternal(rows);
  };

  responseTransformInternal(rows: any[]): any[] {
    rows.forEach((row: any, index: number) => {
      if (Object.prototype.hasOwnProperty.call(row, "AddDtt")) {
        // Change an existing column
        row.AddDtt = "You've been transformed!";

        if (index == 2) {
          row.AddDtt = `Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at
          Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.
          Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the
          Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.`;
        }
      }

      // Add a column - using 'this'
      row.rando = this.getUUID();
    });
    return rows;
  }

  getUUID() {
    return crypto.randomUUID();
  }
}
